<template>
  <v-application>
    <v-layout v-if="!SafeReport" row class="mx-2">
      <v-flex
        v-if="!invValuation"
        style="display: flex; margin-top: 8px"
        :class="salesByItem || invHistory ? 'md2' : 'md3'"
        class="px-2 mt-2 mb-10"
        xs6
      >
        <DatePicker
          class="elevation-1 rounded text--black"
          v-model="options.startdate"
          :clearable="false"
          :placeholder="`${new Date(
            new Date().setDate(new Date().getDate() - 7)
          )
            .toISOString()
            .slice(0, 10)} ${new Date().toLocaleTimeString().slice(0, 4)}`"
          :type="PartitionItem ? 'date' : 'datetime'"
          format="YYYY-MM-DD HH:mm"
          :showSecond="false"
          showMinute
          :minute-step="1"
          :disabled-date="notAfterToday"
        />
      </v-flex>
      <v-flex
        v-if="!invValuation"
        style="display: flex; margin-top: 8px"
        :class="salesByItem || invHistory ? 'md2' : 'md3'"
        class="px-2 mt-2 mb-10"
        xs6
      >
        <DatePicker
          class="elevation-1 rounded"
          v-model="options.enddate"
          :clearable="false"
          :placeholder="`${new Date().toISOString().slice(0, 10)} ${new Date()
            .toLocaleTimeString()
            .slice(0, 4)}`"
          :type="PartitionItem ? 'date' : 'datetime'"
          :showSecond="false"
          showMinute
          format="YYYY-MM-DD HH:mm"
          :minute-step="1"
          :disabled-date="notAfterTodayAndNotBeforeStartDate"
          :default-value="new Date().setHours(23, 59, 59, 999)"
        />
      </v-flex>
      <v-flex
        v-if="
          !workgroupOrder &&
          !invHistory &&
          !invValuation &&
          !itemsPriceHistory &&
          !Consumption &&
          !PartitionItem &&
          !invHistoryReport
        "
        class="px-2 mt-2"
        md2
        xs4
      >
        <v-menu
          offset-y
          v-bind:close-on-content-click="false"
          max-width="250"
          min-width="250"
        >
          <template #activator="{ on }">
            <v-text-field
              item-text="name"
              solo
              dense
              v-on="on"
              hide-details
              v-bind:value="
                options.custom
                  ? options.start.text + ' - ' + options.end.text
                  : $t('all_day')
              "
              prepend-inner-icon="mdi-clock-outline"
              readonly
            />
          </template>
          <v-card>
            <v-list style="padding-top: 0">
              <v-radio-group
                class="pt-1 mt-1"
                v-model="options.custom"
                hide-details
              >
                <v-list-item v-on:click="options.custom = false">
                  <v-list-item-action style="margin-right: 10px">
                    <v-radio v-bind:value="false" />
                  </v-list-item-action>
                  <v-list-item-content>{{ $t("all_day") }}</v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-list-item v-on:click="options.custom = true">
                  <v-list-item-action style="margin-right: 10px">
                    <v-radio v-bind:value="true" />
                  </v-list-item-action>
                  <v-list-item-content>{{ $t("custom") }}</v-list-item-content>
                </v-list-item>
              </v-radio-group>
            </v-list>
            <v-card-text v-if="options.custom" style="padding-top: 0">
              <v-layout>
                <v-flex class="pr-1">
                  <v-combobox
                    v-model="options.start"
                    :label="$t('start')"
                    v-bind:items="times"
                  />
                </v-flex>
                <v-flex class="pl-1">
                  <v-combobox
                    v-model="options.end"
                    :label="$t('end')"
                    v-bind:items="times"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-flex>
      <v-flex v-if="!workgroupOrder && !inv" class="px-2 mt-2" md2 xs4>
        <v-combobox
          v-if="!inv"
          v-model="store"
          v-bind:items="stores"
          item-text="name"
          solo
          dense
          prepend-inner-icon="mdi-store"
        />
      </v-flex>
      <v-flex
        v-if="invHistory || salesByItem || invHistoryReport"
        class="px-2 mt-2"
        md2
        xs4
      >
        <v-autocomplete
          v-model="options.category"
          @change="update_reports"
          v-bind:items="categories"
          item-text="name"
          item-value="_id"
          solo
          dense
          prepend-inner-icon="mdi-shape"
        />
      </v-flex>
      <v-flex
        v-if="
          !workgroupOrder &&
          !invValuation &&
          !PartitionItem &&
          !invHistoryReport
        "
        class="px-2 mt-2"
        md2
        xs4
      >
        <v-combobox
          item-text="name"
          solo
          dense
          v-model="options.employee"
          v-bind:items="employees"
          prepend-inner-icon="mdi-account"
        />
      </v-flex>
      <v-flex v-if="invHistory || invHistoryReport" class="px-2 mt-2" md2 xs4>
        <v-combobox
          item-text="name"
          item-value="value"
          solo
          dense
          v-model="options.reason"
          v-bind:items="reasons"
          prepend-inner-icon="mdi-account"
        />
      </v-flex>
      <template>
        <slot name="top" />
      </template>
    </v-layout>
    <v-card class="ma-2 mt-n4" :loading="chart_loading">
      <slot name="header" />
    </v-card>
    <v-lazy
      v-model="isActive"
      :options="{
        threshold: 0.5,
      }"
      min-height="200"
      transition="fade-transition"
    >
      <v-card class="ma-2">
        <v-toolbar flat v-if="!Consumption">
          <template>
            <slot name="search_text_right" />
          </template>

          <v-spacer />

          <template>
            <slot name="search_text" />
          </template>
          <template v-if="invValuation">
            <!-- <v-btn icon @click="downloadExcel">
              <v-icon>mdi-download</v-icon>
            </v-btn> -->
            <v-dialog v-model="dialog" max-width="500px">
              <v-card>
                <v-card-title>Excel yuklashga tayyor</v-card-title>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn text color="primary" @click="dialog = false">
                    <export-excel
                      :data="downExcel"
                      :fields="jsonProperties"
                      :name="excel_name"
                      >Save Excel
                    </export-excel>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <v-menu
            v-if="!invHistory && !itemsPriceHistory && !PartitionItem"
            offset-y
            v-bind:close-on-content-click="false"
          >
            <template #activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>mdi-table-column</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-list dense>
                <v-list-item
                  v-for="(header, index) in headers"
                  v-bind:key="index"
                >
                  <v-list-item-action>
                    <v-checkbox
                      hide-details
                      v-model="header.available"
                      v-bind:disabled="header.disabled"
                    />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ header.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </v-toolbar>

        <v-data-table
          v-if="!Consumption"
          :loading="data_loading"
          hide-default-footer
          v-bind:headers="computed_headers"
          v-bind:items="data"
          @click:row="row"
          :mobile-breakpoint="0"
          disable-sort
        >
          <template #[`item.history_type`]="{ item }">
            {{ $t(item.history_type) }}
          </template>
          <template #[`item.is_charged`]="{ item }">
            <v-icon v-if="item.is_charged" color="success">mdi-check</v-icon>
            <v-icon v-else color="error">mdi-close</v-icon>
          </template>
          <template v-if="Payment" #[`item.type`]="{ item }"
            >{{ $t(item.type) }}
          </template>
          <template #[`item.gross_sales_analysis`]="{ item }">
            <v-chip
              dark
              :color="
                item.gross_sales_analysis == 'A'
                  ? '#32C955'
                  : item.gross_sales_analysis == 'B'
                  ? '#FFA101'
                  : '#E55454'
              "
              >{{ item.gross_sales_analysis }}
            </v-chip>
          </template>
          <template #[`item.net_sales_analysis`]="{ item }">
            <v-chip
              dark
              :color="
                item.net_sales_analysis == 'A'
                  ? '#32C955'
                  : item.net_sales_analysis == 'B'
                  ? '#FFA101'
                  : '#E55454'
              "
              >{{ item.net_sales_analysis }}
            </v-chip>
          </template>
          <template #[`item.gross_profit_analysis`]="{ item }">
            <v-chip
              dark
              :color="
                item.gross_profit_analysis == 'A'
                  ? '#32C955'
                  : item.gross_profit_analysis == 'B'
                  ? '#FFA101'
                  : '#E55454'
              "
              >{{ item.gross_profit_analysis }}
            </v-chip>
          </template>
          <template #[`item.name`]="{ item }">
            <div :class="item.variant_of ? 'text-center' : ''">
              {{ item.name }}
            </div>
          </template>
          <template #[`item.category`]="{ item }">
            <div>{{ !item.variant_of ? item.category : "" }}</div>
          </template>

          <template #[`item.modifier_name`]="{ item }">
            <div
              :class="item.modifier_name ? 'font-weight-bold' : 'text-center'"
            >
              <v-icon v-if="item.modifier_name" large color="primary"
                >mdi-file-document-outline
              </v-icon>
              {{ item.modifier_name ? item.modifier_name : item.option_name }}
            </div>
          </template>

          <template #[`item.quantity_sold`]="{ item }">
            <div :class="item.modifier_name ? 'font-weight-bold' : ''">
              {{ item.quantity_sold }}
            </div>
          </template>

          <template #[`item.gross_sales`]="{ item }">
            <div :class="item.modifier_name ? 'font-weight-bold' : ''">
              {{ item.gross_sales.toLocaleString() }}
            </div>
          </template>
          <template #[`item.debt`]="{ item }">
            <div :class="item.modifier_name ? 'font-weight-bold' : ''">
              {{ item.debt.toLocaleString() }}
            </div>
          </template>
          <template #[`item.reciepts_count`]="{ item }">
            {{ item.recepts_count }}
          </template>
          <template #[`item.average_reciept`]="{ item }">
            {{
              Math.round(item.gross_sales / item.recepts_count).toLocaleString()
            }}
          </template>

          <template #[`item.quantity_refunded`]="{ item }">
            <div :class="item.modifier_name ? 'font-weight-bold' : ''">
              {{ item.quantity_refunded }}
            </div>
          </template>

          <template #[`item.refunds`]="{ item }">
            <div :class="item.modifier_name ? 'font-weight-bold' : ''">
              {{ item.refunds }}
            </div>
          </template>
          <!-- -->
          <template v-if="invHistory" #[`item.reason`]="{ item }">
            {{
              item.type == "box_item"
                ? item.reason + ` -> ${$t("reminder_changed")}`
                : item.reason
            }}
          </template>
          <!-- -->
          <template #[`item.net_sales`]="{ item }">
            <div :class="item.modifier_name ? 'font-weight-bold' : ''">
              {{ item.net_sales }}
            </div>
          </template>
          <template v-if="invValuation" #[`item.inv_name`]="{ item }">
            <!-- <p class="pa-0 ma-0" :class="item.item_type == 'variant'?'pl-5':''">{{item.name}}</p> -->
            <v-list-item-content
              :class="item.item_type == 'variant' ? 'pl-5' : ''"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle class="caption grey--text" v-if="item.sku"
                >SKU {{ item.sku }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                class="caption grey--text"
                v-if="
                  typeof item.barcode == typeof [] && item.barcode.length > 0
                "
              >
                <span v-for="(barcode, ind) in item.barcode" :key="ind">{{
                  barcode + ", "
                }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template v-if="invValuation" #[`item.cost`]="{ item }">
            <p class="pa-0 ma-0">
              {{
                item.has_variants
                  ? ""
                  : item.cost
                  ? item.cost.toLocaleString()
                  : item.cost
              }}
            </p>
          </template>
          <template v-if="invValuation" #[`item.inventory`]="{ item }">
            {{
              item.inventory ? item.inventory.toLocaleString() : item.inventory
            }}
          </template>
          <template v-if="invValuation" #[`item.retail`]="{ item }">
            {{ item.retail ? item.retail.toLocaleString() : item.retail }}
          </template>
          <template v-if="invValuation" #[`item.potential`]="{ item }">
            {{
              item.potential ? item.potential.toLocaleString() : item.potential
            }}
          </template>
          <template v-if="invValuation" #[`item.margin`]="{ item }">
            {{
              item.potential && item.inventory
                ? Math.round((item.potential / item.inventory) * 100)
                : 0
            }}
            %
          </template>

          <!-- Workgroup reports -->
          <template #[`item.priority`]="{ item }">
            {{ $t(item.priority) }}
          </template>
          <template #[`item.createdAt`]="{ item }">
            {{ date_ddmmyy_hhmm(item.createdAt) }}
          </template>
          <template #[`item.state`]="{ item }">
            {{ $t(item.state) }}
          </template>
          <template #[`item.date`]="{ item }">
            {{
              SafeReport ? date_ddmmyy_hhmm(item.date) : date_ddmmyy(item.date)
            }}
          </template>
          <template #[`item.quantity_left`]="{ item }">
            {{ Math.round(item.quantity_left) }}
          </template>
        </v-data-table>

        <template v-if="value && numPages && !Consumption">
          <v-pagination
            v-model="pagination_value"
            v-bind:length="numPages"
            total-visible="7"
            @input="paginationChange"
            @next="paginationChange"
            @previous="paginationChange"
            class="elevation-0"
          ></v-pagination>
        </template>
      </v-card>
    </v-lazy>
    <slot name="drawer" />
  </v-application>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/scss/index.scss";

import Services from "../../mixins/services";
import moment from "moment";

var now = new Date();
export default {
  components: {
    DatePicker,
  },
  name: "v-reports",
  mixins: [Services],
  data: () => ({
    downExcel: [],
    excel_name: "Valuation Excel Export",
    jsonProperties: {
      Id: "_id",
    },
    isActive: false,
    dialog: false,
    pagination_value: 1,
    first_time: true,
    start_date_for_summary: new Date(now.setHours(0, 0, 0, 0)),
    end_date_for_summary: new Date(now.setHours(0, 0, 0, 0)),
    options: {
      start_date: new Date(new Date().setDate(now.getDate() - 7)).toISOString(),
      end_date: new Date(new Date().setDate(now.getDate())).toISOString(),
      custom: false,
      employee: null,
      category: null,
      supplier: {
        supplier_name: "",
        _id: "",
      },
      reason: {
        name: "All reasons",
        value: "",
      },
      start: { text: "12 AM", time: 0 },
      end: { text: "11 PM", time: 23 },
    },
    times: [],
    employees: [],
    categories: [],
    all_suppliers: [],
    reasons: [
      {
        name: "All reasons",
        value: "",
      },
      {
        name: "Sale",
        value: "sold",
      },
      {
        name: "Refund",
        value: "returned",
      },
      {
        name: "Receive items",
        value: "received",
      },
      {
        name: "Returned back",
        value: "returned_order",
      },
      {
        name: "Transfer",
        value: "transferred",
      },
      {
        name: "Inventory count",
        value: "recounted",
      },
      {
        name: "Damage",
        value: "damaged",
      },
      {
        name: "Loss",
        value: "lost",
      },
      {
        name: "Production",
        value: "production",
      },
      {
        name: "Item edit",
        value: "item edit",
      },
    ],
  }),
  props: {
    value: Number,
    data_loading: {
      type: Boolean,
      default: false,
    },
    chart_loading: {
      type: Boolean,
      default: false,
    },
    numPages: Number,
    headers: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    update: Function,
    row: { type: Function, default: () => {} },
    invHistory: Boolean,
    invHistoryReport: Boolean,
    salesByItem: Boolean,
    itemsPriceHistory: Boolean,
    invValuation: Boolean,
    Payment: Boolean,
    Consumption: Boolean,
    workgroupOrder: Boolean,
    SafeReport: Boolean,
    inv: Boolean,
    summary: Boolean,
    receipt: Boolean,
    PartitionItem: Boolean,
  },
  computed: {
    computed_headers() {
      const headers = [];
      for (const index in this.headers) {
        if (this.headers[index].available) {
          headers.push(this.headers[index]);
        }
      }
      return headers;
    },
  },
  methods: {
    notAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return (
        date > today ||
        date > (this.options.enddate !== null ? this.options.enddate : today)
      );
    },
    notAfterTodayAndNotBeforeStartDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < this.options.start_date - 86400000;
    },
    async downloadExcel() {
      this.loading = true;
      this.dialog = true;
      try {
        const token = this.invan_user ? this.invan_user.token : "";
        const link = `/invan-download/inventory/valuation/excel-file?token=${token}&type=json`;
        const invvaluation = await this.$communicator.getMethod(link);
        this.loading = false;
        const downExcel =
          invvaluation &&
          invvaluation.data &&
          invvaluation.data.data &&
          invvaluation.data.data.data
            ? invvaluation.data.data.data
            : [];
        this.loader = false;
        for (const [index, item] of downExcel.entries()) {
          downExcel[index].date = moment(item.date).format("DD.MM.YYYY MM:HH");
        }
        this.dovnExcel = downExcel;
        // console.log(downExcel);
        // const box = xlsx.utils
        // const start_date = new Date(this.params.start_date).getTime();
        // const end_date = new Date(this.params.end_date).getTime();
        // const token = this.invan_user ? this.invan_user.token : "";
        // const link = `invan-download/inventory/history/excel-file?token=${token}&min=${start_date}&max=${end_date}`;
        // // const link = `inventory/history/excel-file?token=${token}&min=${start_date}&max=${end_date}`;
        // this.$communicator.downloadDocument(link, `history.xls`);
      } catch (err) {
        // console.log(err.message);
      }
    },
    paginationChange() {
      this.$emit("change-pagination", this.pagination_value);
    },
    async update_reports() {
      const employees = this.$communicator.then(
        this,
        await this.$communicator("all_employees", {
          params: {
            service: this.store?._id,
          },
        })
      );
      if (employees instanceof Array) {
        this.employees = [
          { name: this.$t("all_employees"), _id: "" },
          ...this.$copy(employees),
        ];
        var is = true;
        if (this.options.employee !== null) {
          for (const index in this.employees) {
            if (this.options.employee._id == this.employees[index]._id)
              is = false;
          }
        }
        if (is) this.options.employee = this.$copy(this.employees[0]);
        if (this.update) {
          this.update({ service: this.store?._id, ...this.options });
        }
      }

      if (this.invHistory || this.salesByItem || this.invHistoryReport) {
        const categories = this.$communicator.then(
          this,
          await this.$communicator("list_of_all_categories")
        );

        if (categories instanceof Array) {
          this.categories = [
            { name: this.$t("all_categories"), _id: "" },
            ...this.$copy(categories),
          ];
          let is_category = true;
          if (this.options.category !== null) {
            for (const index in this.categories) {
              if (this.options.category === this.categories[index]._id) {
                is_category = false;
              }
            }
          }
          if (is_category) this.options.category = this.categories[0]._id;
          if (this.update) {
            this.update({ service: this.store?._id, ...this.options });
          }
        }
      }
      // if (this.salesByItem) {
      //   const all_suppliers = this.$communicator.then(
      //     this,
      //     await this.$communicator("all_suppliers")
      //   );
      //   if (all_suppliers instanceof Array) {
      //     this.all_suppliers = [
      //       { supplier_name: this.$t("all_suppliers"), _id: "" },
      //       ...this.$copy(all_suppliers),
      //     ];
      //     let is_sup = true;
      //     if (this.options.supplier !== null) {
      //       for (let index in this.all_suppliers) {
      //         if (
      //           this.options.supplier?._id === this.all_suppliers[index]._id
      //         ) {
      //           is_sup = false;
      //         }
      //       }
      //     }
      //     if (is_sup) this.options.supplier = this.all_suppliers[0];
      //     if (this.update) {
      //       this.update({ service: this.store._id, ...this.options });
      //     }
      //   }
      // }
    },
  },
  beforeMount() {
    this.options = this.$store.state.options;
    this.store = this.$store.state.items_current_service;
  },
  mounted() {
    if (this.invHistory || this.invHistoryReport) {
      this.reason = {
        name: this.$t("all_reasons"),
        value: "",
      };
      this.reasons = [
        {
          name: this.$t("all_reasons"),
          value: "",
        },
        {
          name: this.$t("sales"),
          value: "sold",
        },
        {
          name: this.$t("refund"),
          value: "returned",
        },
        {
          name: this.$t("receive_items"),
          value: "received",
        },
        {
          name: this.$t("returned_back"),
          value: "returned_order",
        },
        {
          name: this.$t("transferred"),
          value: "transferred",
        },
        {
          name: this.$t("inventory_count"),
          value: "recounted",
        },
        {
          name: this.$t("damage"),
          value: "damaged",
        },
        {
          name: this.$t("loss"),
          value: "lost",
        },
        {
          name: this.$t("production"),
          value: "production",
        },
        {
          name: this.$t("edit_items"),
          value: "item edit",
        },
      ];
    }
    for (var i = 0; i < 24; i++) {
      const time =
        (i % 12 == 0 ? 12 : i % 12).toString() + (i < 12 ? " AM" : " PM");
      this.times.push({ text: time, time: i });
    }
    this.update_reports();
  },
  updated() {
    this.first_time = true;

    if (this.value != this.pagination_value) {
      this.pagination_value = this.value;
    }
  },
  watch: {
    start_date_for_summary: {
      handler() {
        this.options.start_date = new Date(
          new Date(this.start_date_for_summary).getTime()
        );
        this.update_reports();
        this.$store.commit("setOptions", this.options);
      },
    },
    end_date_for_summary: {
      handler() {
        this.options.end_date = new Date(
          new Date(this.end_date_for_summary).getTime()
        );
        this.update_reports();
        this.$store.commit("setOptions", this.options);
      },
    },
    "options.startdate": {
      handler() {
        this.options.start_date = new Date(
          new Date(this.options.startdate).getTime()
        );
        this.update_reports();
        this.$store.commit("setOptions", this.options);
      },
    },
    "options.enddate": {
      handler() {
        this.options.end_date = new Date(
          new Date(this.options.enddate).getTime()
        );
        if (this.first_time) {
          this.update_reports();
          this.$store.commit("setOptions", this.options);
        }
      },
    },
    "options.custom": {
      handler() {
        if (this.first_time) {
          this.update_reports();
          this.$store.commit("setOptions", this.options);
        }
      },
    },
    "options.employee._id": {
      handler() {
        if (this.first_time) {
          this.update_reports();
          this.$store.commit("setOptions", this.options);
        }
      },
    },
    "options.category": {
      handler() {
        if (this.first_time) {
          this.update_reports();
          this.$store.commit("setOptions", this.options);
        }
      },
    },
    "options.reason.value": {
      handler() {
        if (this.first_time) {
          this.update_reports();
          this.$store.commit("setOptions", this.options);
        }
      },
    },
    "options.start": {
      handler() {
        if (this.first_time) {
          this.update_reports();
          this.$store.commit("setOptions", this.options);
        }
      },
    },
    "options.end": {
      handler() {
        if (this.first_time) {
          this.update_reports();
          this.$store.commit("setOptions", this.options);
        }
      },
    },
    "store._id": {
      handler() {
        if (this.first_time) {
          this.update_reports();
          this.$store.commit("setOptions", this.options);
        }
      },
    },
    store() {
      this.$store.commit("setItemsService", this.store);
    },
    "options.supplier": {
      deep: true,
      handler() {
        this.update_reports();
        this.$store.commit("setOptions", this.options);
      },
    },
    // "options.category._id": {
    //   deep: true,
    //   handler() {
    //     this.update_reports();
    //     this.$store.commit("setOptions", this.options);
    //   },
    // },
  },
  destroyed() {
    if (this.options.supplier) this.options.supplier._id = "";
  },
};
</script>

<style lang="scss">
@import "~vue2-datepicker/scss/var.scss";
@import "~vue2-datepicker/scss/icon.scss";
@import "~vue2-datepicker/scss/btn.scss";
@import "~vue2-datepicker/scss/scrollbar.scss";
@import "~vue2-datepicker/scss/animation.scss";

.width100 {
  width: 160px !important;
}
.width200 {
  min-width: 160px !important;
}

@media (min-width: 1537px) {
  .width100 {
    min-width: 245px;
  }
  .width200 {
    min-width: 400px;
  }
}

.#{$namespace}-datepicker {
  position: relative;
  display: inline-block;
  width: 400px;
  svg {
    width: 1.2em;
    height: 1.2em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
}

.#{$namespace}-datepicker-range {
  width: 320px;
}

.#{$namespace}-datepicker-inline {
  width: auto;
}

.#{$namespace}-input-wrapper {
  position: relative;
  .#{$namespace}-icon-clear {
    display: none;
  }
  &:hover {
    .#{$namespace}-icon-clear {
      display: block;
      color: rgba(0, 0, 0, 0.8);
    }
    .#{$namespace}-icon-clear + .#{$namespace}-icon-calendar {
      display: none;
    }
  }
}

.#{$namespace}-input {
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  height: 38px;
  padding: 10px 2px 6px 10px;
  font-size: 14.7px;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.9) !important;
  background-color: #fff;
  border: 1px solid $input-border-color;
  border-radius: $input-border-radius;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);

  &:hover,
  &:focus {
    border-color: $input-hover-border-color;
  }
  &:disabled,
  &.disabled {
    color: $disabled-color;
    background-color: $disabled-background-color;
    border-color: $input-border-color;
    cursor: not-allowed;
  }
  &:focus {
    outline: none;
  }
  &::-ms-clear {
    display: none;
  }
}

.#{$namespace}-icon-calendar,
.#{$namespace}-icon-clear {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  font-size: 16px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.8);
  vertical-align: middle;
}

.#{$namespace}-icon-clear {
  cursor: pointer;
  &:hover {
    color: rgba(0, 0, 0, 0.8);
  }
}
</style>